import { PropTypes } from 'prop-types';
import React, { useState, useEffect } from 'react';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import { Icon } from '@pwc/pwc-deals-ui';
import { getAllStructuredIngestionDocuments } from 'common/engine/services/structuredAnalysisService';
import showAutosync from 'common/helpers/ShowAutosync.ts';
import SyncedInfo from 'common/components/Autosync/SyncedInfo.tsx';
import { useSyncedInfo } from 'common/components/Autosync/SyncedInfoProvider.tsx';
import './AutosyncedSource.scss';

const AutosyncedSource = ({ projectId, contentSubType }) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const [document, setDocument] = useState({});
  const { shareWithAll } = useSyncedInfo();
  useEffect(() => {
    async function fetchData() {
      const canShowAutosync = await showAutosync(projectId, isPwcUser);
      if (canShowAutosync) {
        const response = await getAllStructuredIngestionDocuments(projectId);
        if (response) {
          const doc = response.find(
            (rs) => rs.contentSubType === contentSubType
          );
          setDocument(doc);
        }
      }
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, isPwcUser]);

  if (document && document.sharePointItemUrl) {
    const { worksheetName, sharePointItemUrl } = document;
    const excelPPTItem = {
      worksheetName,
      fileName: sharePointItemUrl,
      sharePointItemUrl,
    };
    return (
      <div className="auto-synced-source-container">
        {!shareWithAll && (
          <div>
            <Icon
              width="16"
              name="box-arrow-up-right"
              className="fill icon-orange-theme"
            />
          </div>
        )}
        <SyncedInfo
          projectId={projectId}
          excelPPTItem={excelPPTItem}
          isPwcUser={isPwcUser}
        />
      </div>
    );
  }
  return <></>;
};

AutosyncedSource.propTypes = {
  projectId: PropTypes.string.isRequired,
  contentSubType: PropTypes.number.isRequired,
};

export default AutosyncedSource;
